import React, { useContext, useEffect, useState } from "react";
import { EditorContext, ModalServiceContext, RicosContext } from "./../../ricos-context";
import { useSpoilerPlugin } from "./../../_shared/use-spoiler-plugin";
import { videoModals } from "../constants";
import { VideoSettings } from "../modals/VideoSettings";
import { VIDEO_TYPE } from "../types";
const SettingsModal = ({ nodeId }) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const isSpoilerEnabled = useSpoilerPlugin(VIDEO_TYPE);
  const [initialData, setInitialData] = useState();
  const [componentData, setComponentData] = useState();
  useEffect(() => {
    const componentData2 = getEditorCommands().getBlockComponentData(nodeId);
    setInitialData(componentData2);
    setComponentData(componentData2);
  }, []);
  const updateData = (data) => {
    getEditorCommands().setBlock(nodeId, VIDEO_TYPE, { ...componentData, ...data, id: nodeId });
    setComponentData({ ...componentData, ...data });
  };
  const closeModal = () => {
    modalService.closeModal(videoModals.settings);
  };
  const onCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    VideoSettings,
    {
      componentData,
      helpers: {},
      t,
      updateData,
      onSave: closeModal,
      onCancel,
      shouldShowSpoiler: isSpoilerEnabled
    }
  ) : null;
};
export {
  SettingsModal
};
//# sourceMappingURL=SettingsModal.js.map
